import React, { FunctionComponent } from "react";
import { IIconProps } from "../icon";

export const GeneticIcon: FunctionComponent<IIconProps> = (props) => {
  const { color, outlined, ...rest } = props;
  return (
    <svg viewBox="0 0 40 40" {...rest}>
      <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Icons/Test/Genetic">
          <g
            id="Group"
            transform="translate(20.000000, 20.000000) rotate(133.000000) translate(-20.000000, -20.000000) translate(12.000000, 11.000000)"
            stroke="#222222"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
          >
            <path
              d="M0,10.9378165 C2.61837225,8.20336237 7.20052367,15.7231112 10.473489,12.3050435 C13.7464543,8.8869759 7.20052367,3.41806765 10.473489,-1.13686838e-13"
              id="Path"
            ></path>
            <path
              d="M16,7.06218351 C13.3816278,9.79663763 8.79947633,2.2768888 5.52651102,5.69495645 C2.25354571,9.1130241 8.79947633,14.5819323 5.52651102,18"
              id="Path"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  );
};
